/* eslint-disable max-len, padded-blocks */
/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import api from '@/api';

export const namespaced = true;

export const state = {
  memberOf: [],
};

export const actions = {
  fetchMemberOf({ commit, state }) {
    if (state.memberOf.length < 1) {
      return api.get(
        '/membership/me',
      ).then((response) => {
        commit('SET_MEMBER_OF', response.data);
      });
    }
    return commit('SET_MEMBER_OF', state.memberOf);
  },
};

export const mutations = {
  SET_MEMBER_OF(state, memberOf) {
    state.memberOf = memberOf;
  },
};
